import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from "primereact/inputtextarea";
import { ProgressBar } from 'primereact/progressbar';
import { Tag } from 'primereact/tag';
import { Tooltip } from 'primereact/tooltip';
import React, { useEffect, useRef, useState, createRef } from "react";
import PhoneInput from 'react-phone-number-input';
import 'react-slideshow-image/dist/styles.css';
import { _endPoints, setcustomer } from '../Helper/links';
import pattern from '../Helper/pattern';
import API from '../Helper/server/API';
import { useCustomer } from '../customers/useCustomer';
import { Password } from 'primereact/password';
import '../public/themes/saga-blue/theme.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputSwitch } from 'primereact/inputswitch';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Checkbox } from "primereact/checkbox";

function UserEditPermissions(props) {
    // States
    const opInsert = useRef(null);
    const opUpdate = useRef(null);
    const opInsertRefs = useRef({});
    const opUpdateRefs = useRef({});
    const [ID_user, set_ID_user] = useState(null);
    const [name, set_name] = useState("");
    const [email, set_email] = useState("");
    const [whatsapp_number, setwhatsapp_number] = useState("");

    const [change_password, set_change_password] = useState(false);
    const [password, set_password] = useState("");
    const [permissions, set_permissions] = useState("");
    const [phone, set_phone] = useState("");
    const [state, set_state] = useState(true);
    const [error, set_error] = useState({});
    const [loading, set_loading] = useState(false);
    const [loding_update, set_loding_update] = useState(false)
    const UpdateUser = async () => {

        set_loding_update(true);
        var validtion = true
        //_______________________________________________________________________________________
        //                         Validtion
        if (!ID_user || pattern.number_int.test(ID_user) == false) {
            validtion = false
        }
        if (permissions?.length != props?.user?.permissions?.length) {
            validtion = false
        }
        if (!validtion) {
            props.toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.1rem"
                },
                life: 3000,
                severity: 'error', summary: 'خطــاء', detail: "أرجــو إدخــال بيــانات العميــل"
            });
        }
        else {
            const data = {
                ID_user: ID_user,
                permissions: permissions
            }
            const response = await API.post(_endPoints.users.update_permissions, data)
            if (response?.success) {
                // props?.set_users([...props.users,response?.data])
                // props?.set_users_view([...props.users,response?.data])
                props?.GetUsers();
                props?.set_show_permissions_user(false)
                props.toast.current.show({
                    style: {
                        fontSize: "1.2rem",
                        fontFamily: "Cairo"
                    },
                    life: 3000,
                    severity: 'success', summary: ' نجــاح ', detail: response?.msg
                });
            }
            else if (response?.success === 0) {
                props.toast.current.show({
                    style: {
                        fontFamily: "Cairo",
                        fontSize: "1.2rem"
                    },
                    life: 3000,
                    severity: 'error', summary: 'خطــاء', detail: response?.msg
                });
                if (response?.error === "permissions")
                    document.getElementById("lpermissions").style.color = "red"
            }
        }
        set_loding_update(false);
    }

    const view_p_view = (item) => {
        return <InputSwitch checked={item.p_view ? true : false} id={`p_view_${item.ID_permission}`}
            onChange={(e) => {
                set_permissions(permissions.map(p =>
                    p.key === item.key
                        ? { ...p, p_view: !p.p_view }
                        : p
                ))
            }} />
    }
    const view_p_insert = (item) => {
        return <>
            <InputSwitch checked={item.p_insert ? true : false} id={`p_insert_${item.ID_permission}`}
                onChange={(e) => {
                    set_permissions(permissions.map(p =>
                        p.key === item.key
                            ? { ...p, p_insert: !p.p_insert }
                            : p
                    ))
                }} />
            {
                Array.isArray(item.p_insert_data) && item.p_insert_data.length > 0 ?
                    <>
                        <Button
                            label="تحديد البيانات"
                            text

                            onClick={(e) => {
                                const ref = opInsertRefs.current[item.ID_permission];
                                if (ref && ref.current) {
                                    ref.current.toggle(e);
                                }
                            }}
                        />
                        <OverlayPanel
                            ref={opInsertRefs.current[item.ID_permission]}
                            showCloseIcon
                            closeOnEscape
                            dismissable={true}
                            style={{ minWidth: '400px' }}
                            className="custom-overlaypanel"
                        >
                            <DataTable
                                value={
                                    Array.isArray(item.p_insert_data) && item.p_insert_data.length > 0
                                        ? item.p_insert_data
                                        : []
                                }
                                responsiveLayout="scroll"
                                emptyMessage={
                                    Array.isArray(item.p_insert_data) && item.p_insert_data.length > 0
                                        ? null
                                        : <center>لا توجد خيارات متاحة</center>
                                }
                            >
                                <Column
                                    field="value"
                                    header="-"
                                    body={(e) => p_insert_data_check(item, e)}
                                    style={{ textAlign: 'right' }}
                                />
                                <Column field="label" header="البيان" style={{ textAlign: 'right' }} />
                            </DataTable>
                        </OverlayPanel>
                    </>
                    :
                    null
            }
        </>
    }
    const view_p_update = (item) => {
        return <>
            <InputSwitch checked={item.p_update ? true : false} id={`p_update_${item.ID_permission}`}
                onChange={(e) => {
                    set_permissions(permissions.map(p =>
                        p.key === item.key
                            ? { ...p, p_update: !p.p_update }
                            : p
                    ))
                }} />
            {
                Array.isArray(item.p_update_data) && item.p_update_data.length > 0 ?
                    <>
                        <Button
                            label="تحديد البيانات"
                            text
                            onClick={(e) => {
                                const ref = opUpdateRefs.current[item.ID_permission];
                                if (ref && ref.current) {
                                    ref.current.toggle(e);
                                }
                            }}

                        />
                        <OverlayPanel
                            ref={opUpdateRefs.current[item.ID_permission]}
                            showCloseIcon
                            closeOnEscape
                            dismissable={true}
                            style={{ minWidth: '400px' }}
                            className="custom-overlaypanel"
                        >
                            <DataTable
                                value={
                                    Array.isArray(item.p_update_data) && item.p_update_data.length > 0
                                        ? item.p_update_data
                                        : []
                                }
                                responsiveLayout="scroll"
                                emptyMessage={
                                    Array.isArray(item.p_update_data) && item.p_update_data.length > 0
                                        ? null
                                        : <center>لا توجد خيارات متاحة</center>
                                }
                            >
                                <Column
                                    field="value"
                                    header="-"
                                    body={(e) => p_update_data_check(item, e)}
                                    style={{ textAlign: 'right' }}
                                />
                                <Column field="label" header="البيان" style={{ textAlign: 'right' }} />
                            </DataTable>
                        </OverlayPanel>
                    </>
                    : null
            }

        </>
    }
    const view_p_delete = (item) => {
        return <InputSwitch checked={item.p_delete ? true : false} id={`p_delete_${item.ID_permission}`}
            onChange={(e) => {
                set_permissions(permissions.map(p =>
                    p.key === item.key
                        ? { ...p, p_delete: !p.p_delete }
                        : p
                ))
            }} />
    }
    const p_insert_data_check = (parentItem, dataItem) => {
        // Use key as the primary key. Update the correct permission in permissions state array.
        return (
            <Checkbox
                checked={dataItem.value}
                onChange={(e) => {
                    set_permissions(permissions.map(permission =>
                        permission.key === parentItem.key
                            ? {
                                ...permission,
                                p_insert_data: Array.isArray(permission.p_insert_data)
                                    ? permission.p_insert_data.map(d =>
                                        d.key === dataItem.key
                                            ? { ...d, value: !d.value }
                                            : d
                                    )
                                    : []
                            }
                            : permission
                    ))
                }}
            />
        );
    }
    const p_update_data_check = (parentItem, dataItem) => {
        // Use key as the primary key. Update the correct permission in permissions state array.
        return (
            <Checkbox
                checked={dataItem.value}
                onChange={(e) => {
                    set_permissions(permissions.map(permission =>
                        permission.key === parentItem.key
                            ? {
                                ...permission,
                                p_update_data: Array.isArray(permission.p_update_data)
                                    ? permission.p_update_data.map(d =>
                                        d.key === dataItem.key
                                            ? { ...d, value: !d.value }
                                            : d
                                    )
                                    : []
                            }
                            : permission
                    ))
                }}
            />
        );
    }

    useEffect(() => {
        set_ID_user(props?.user?.ID_user)
        set_state(props?.user?.state)
        set_name(props?.user?.name)
        set_phone(props?.user?.phone)
        if (props?.user?.whatsapp_number && props?.user?.whatsapp_number !== "null")
            setwhatsapp_number("+" + props?.user?.whatsapp_number)
        set_email(props?.user?.username)
        // Convert data_insert fields to parsed JSON objects, if any exist
        if (props?.user?.permissions && Array.isArray(props.user.permissions)) {
            props.user.permissions.forEach((perm) => {
                if (perm.data_insert && typeof perm.data_insert === "string") {
                    try {
                        perm.data_insert = JSON.parse(perm.data_insert);
                    } catch (e) {
                        // ignore parse error, leave as-is
                    }
                }
                if (perm.p_insert_data && typeof perm.p_insert_data === "string" && perm.p_insert_data.length > 0) {
                    try {
                        perm.p_insert_data = JSON.parse(perm.p_insert_data);
                    } catch (e) {
                        perm.p_insert_data = perm.data_insert
                        // ignore parse error, leave as-is
                    }
                }
                else {
                    perm.p_insert_data = perm.data_insert
                }
                //__________________________________________________________________________________________
                if (perm.data_update && typeof perm.data_update === "string") {
                    try {
                        perm.data_update = JSON.parse(perm.data_update);
                    } catch (e) {
                        // ignore parse error, leave as-is
                    }
                }
                if (perm.p_update_data && typeof perm.p_update_data === "string") {
                    try {
                        perm.p_update_data = JSON.parse(perm.p_update_data);
                    } catch (e) {
                        // ignore parse error, leave as-is
                        perm.p_update_data = perm.data_update
                    }
                }
                else {
                    perm.p_update_data = perm.data_update
                }
            });
        }
        set_permissions(props?.user?.permissions || [])
        props?.user?.permissions?.forEach(p => {
            if (!opUpdateRefs.current[p.ID_permission]) {
                opUpdateRefs.current[p.ID_permission] = createRef();
            }
            if (!opInsertRefs.current[p.ID_permission]) {
                opInsertRefs.current[p.ID_permission] = createRef();
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <div className="ibox">
            <div className='obox-body'>
                <div className='col-md-12 mt-4'>
                    <div className="row"  >
                        <div className="col-md-2  mb-4">
                            <label id="lstate" className='col-md-12'>  حــالة الحســاب
                                <i className="ti ti-note pr-1" ></i>
                            </label>
                            <Button icon={state ? "pi true-icon pi-check ml-2" : "pi false-icon pi-times ml-2"} label={state ? "فعـــال" : "متــوقف"} outlined severity={state ? "success" : "danger"} size="large" className='mr-1'
                                disabled />
                        </div>

                        <div className="col-md-5">
                            <label id="lname"> الأسم بالكامل *
                                <i className="ti ti-user pr-1" ></i>
                            </label>
                            < label id="msg_customer" style={{ paddingRight: "50px" }}></label>
                            <InputText value={name}
                                maxLength={255} placeholder=" الاسم" className="col-md-12 " style={{ fontFamily: "Cairo", color: "black" }} inputStyle={{ fontFamily: "Cairo" }} panelStyle={{ fontFamily: "Cairo", textAlign: "right" }}
                                virtualScrollerOptions={{ itemSize: 38 }} field="name" dropdown disabled scrollHeight="400px" />
                        </div>

                        <div className="col-md-2">
                            <label id="lphone"> رقم الهاتف *
                                <i className="fa fa-phone pr-1" ></i>
                            </label>
                            <div className="p-inputgroup flex-1">
                                <InputText value={phone} maxLength={9} placeholder="9x1234567" style={{ fontFamily: "Cairo", textAlign: "left", color: "black" }}
                                    disabled />
                                <span className="p-inputgroup-addon" dir='ltr' style={{ borderRight: "0 nane", borderLeft: "1px solid #ced4da" }}>+218</span>

                            </div>
                        </div>
                        <div className="col-md-3">
                            <label id="lwhatsapp_number"> رقم واتس اب
                                <i className="fa fa-whatsapp pr-1" ></i>
                            </label>
                            <div className="input-group" dir="ltr">
                                <PhoneInput
                                    country='LY'
                                    showValue
                                    // defaultCountry="LY"
                                    placeholder="ادخل رقم واتس اب"
                                    value={whatsapp_number} maxLength={15} name="whatsapp_number" id="whatsapp_number"
                                    disabled style={{ color: "black" }}
                                    className="p-inputtext p-component p-autocomplete-input p-autocomplete-dd-input p-autocomplete-input p-autocomplete-dd-input col-md-12 pr-0"
                                />
                            </div>
                        </div>
                    </div>
                    <hr></hr>
                    <div className='row'>
                        <div className="col-md-4 mb-4">
                            <label id="lemail">البريد الإلكتروني </label>
                            <InputText
                                value={email}
                                disabled style={{ color: "black" }}
                                className="w-100"
                                placeholder="ادخل البريد الإلكتروني"
                            />
                            {error.email && <small className="text-danger">{error.email}</small>}
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className="card">
                                <div className="flex justify-content-center align-items-center mb-4 gap-2">
                                    <center >
                                        <h5 className='pt-4' id="lpermissions">صـــلاحيات</h5>
                                    </center>
                                </div>
                                <DataTable
                                    value={permissions}
                                    selectionMode={'checkbox'}
                                    selection={[]} showGridlines size='large' key='ID_permission'>
                                    <Column field="label" header="الصلاحية" style={{ textAlign: "right", fontWeight: "bold" }} headerStyle={{ textAlign: "center " }}></Column>
                                    <Column field="name" header="عرض" body={view_p_view} style={{ textAlign: "right" }} headerStyle={{ textAlign: "center" }}></Column>
                                    <Column field="category" header="إضافة" body={view_p_insert} style={{ textAlign: "right", width: "15rem" }} headerStyle={{ textAlign: "center" }}></Column>
                                    <Column field="quantity" header="تعديل" body={view_p_update} style={{ textAlign: "right", width: "15rem" }} headerStyle={{ textAlign: "center" }}></Column>
                                    <Column field="quantity" header="إلغاء" body={view_p_delete} style={{ textAlign: "right" }} headerStyle={{ textAlign: "center" }}></Column>
                                </DataTable>

                            </div>
                        </div>

                    </div>
                    <div className='row' style={{ paddingTop: "2rem" }}>
                        <div className="col-md-12" style={{ paddingTop: "40px" }}>
                            <center>
                                <Button label=" تعـــديل صـــلاحيات المستخـــدم " dir='rtl' raised className="pl-4 pr-4" style={{ fontFamily: "Cairo", margin: "1" }} onClick={UpdateUser} loading={loding_update} />
                            </center>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserEditPermissions